import { DOMAIN, isDeployed, TOKEN_EXPIRATION_TIME } from '@core/lib/utils'

export const sessionCookieOptions = {
  path: '/',
  expires: new Date(Date.now() + TOKEN_EXPIRATION_TIME * 1000),
  sameSite: 'strict' as const,
  secure: isDeployed,
  ...(isDeployed ? { domain: DOMAIN } : {})
}
